function i(d) {
  const t = document.querySelector("html"), e = window.innerWidth - document.documentElement.clientWidth;
  d ? (t?.classList.add("is-hidden"), document.body.style.paddingRight = `${e}px`) : (t?.classList.remove("is-hidden"), document.body.style.paddingRight = "");
}
export {
  i as toogleHiddenClass
};
